export enum ReservationType {
    Dropoff = 1,
    Pickup = 2,
    ['Will-Call'] = 3,
}
